import * as Yup from 'yup';
import { jobApplicationHrUsers } from '../../constants';

export const updateSupervisorFormValidationSchema = Yup.object({
  supervisor: Yup
    .string().required('Il campo gestore HR è obbligatorio')
    .oneOf(jobApplicationHrUsers.map((option) => option.email), 'Selezionare un gestore HR valido'),
});
